import React from 'react';
import Icon from '@components/AppIcon';
import Button from '@components/ui/Button';

const QuickContactCards = () => {
  const quickContactOptions = [
    {
    id: 1,
    title: "Call to Book Appointment",
    description: "Schedule your eye consultation over the phone.",
    icon: "Phone",
    action: "Call Now",
    contact: "+254 718 202 020",
    availability: "Mon-Fri: 8:30AM - 5:00PM, Sat: 9:00AM - 1:00PM",
    bgGradient: "from-blue-100 to-blue-50",
    iconColor: "text-[#08005f]",
    buttonVariant: "default"
  },
    {
      id: 2,
    title: "Visit Us",
    description: "Walk in for general inquiries and assistance at the front desk.",
    icon: "MapPin",
    action: "Get Directions",
    contact: "Nairobi & Nakuru Branches",
    availability: "Mon-Fri: 8:30AM - 5:00PM, Sat: 9:00AM - 1:00PM",
    bgGradient: "from-gray-100 to-gray-50",
    iconColor: "text-[#eb2227]",
    buttonVariant: "outline"
    },
    {
      id: 3,
      title: "Book Appointment",
      description: "Easily schedule your eye consultation online with our specialists.",
      icon: "Calendar",
      action: "Schedule Now",
      contact: "Online Booking",
      availability: "Available 24/7",
      bgGradient: "from-blue-100 to-blue-50",
      iconColor: "text-[#08005f]",
      buttonVariant: "default"
    },
    {
      id: 4,
      title: "General Inquiries",
      description: "For insurance, services, or general information, reach out via email.",
      icon: "Mail",
      action: "Send Email",
      contact: "info@eyenu.com",
      availability: "Responses within 2 business hours",
      bgGradient: "from-gray-100 to-gray-50",
      iconColor: "text-[#eb2227]",
      buttonVariant: "outline"
    }
  ];

  const handleContactAction = (option) => {
    switch (option.id) {
      case 1:
        window.location.href = `tel:${option.contact}`;
        break;
      case 2:
        window.location.href = '/locations-community-health-hub-network';
        break;
      case 3:
        window.location.href = '/book-appointment-guided-care-journey';
        break;
      case 4:
        window.location.href = `mailto:${option.contact}`;
        break;
      default:
        break;
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#eb2227]/5 via-white to-[#08005f]/5">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-[#08005f] mb-4">
            Choose Your Preferred Contact Method
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We’ve made it simple for you to reach us — whether it’s urgent eye care, booking
            appointments, or just asking a question.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickContactOptions.map((option) => (
            <div
              key={option.id}
              className={`relative rounded-2xl bg-gradient-to-br ${option.bgGradient} p-6 shadow-md hover:shadow-xl transition-all duration-300`}
            >
              {/* Icon */}
              <div
                className={`w-16 h-16 ${option.iconColor} bg-white rounded-xl flex items-center justify-center mx-auto mb-4 shadow-sm`}
              >
                <Icon name={option.icon} size={28} />
              </div>

              {/* Title */}
              <h3 className="font-heading font-bold text-xl text-[#08005f] mb-2 text-center">
                {option.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm mb-4 text-center leading-relaxed">
                {option.description}
              </p>

              {/* Contact Info */}
              <div className="text-center mb-6">
                <p className="font-semibold text-[#eb2227]">{option.contact}</p>
                <p className="text-xs text-gray-500">{option.availability}</p>
              </div>

              {/* Action Button */}
              <Button
                variant={option.buttonVariant}
                size="sm"
                fullWidth
                onClick={() => handleContactAction(option)}
                className="bg-gradient-to-r from-[#08005f] to-[#08005f] hover:from-[#eb2227]/90 hover:to-[#eb2227]/90 text-white font-medium shadow-md hover:shadow-lg"
              >
                {option.action}
              </Button>
            </div>
          ))}
        </div>

        {/* Footer Info */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 bg-gray-100 px-4 py-2 rounded-full">
            <Icon name="Info" size={16} className="text-[#eb2227]" />
            <span className="text-sm text-gray-600">
              Your safety is our priority — all communications are secure and confidential.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickContactCards;
